import React from 'react'
import { Flex, Span, PopOver } from '@fareye/ui'
import { FaEllipsisV, FaFileDownload } from '@fareye/utils'
import { downloadToCSV, useTranslation } from '@fareye/common'

import { MoreActions } from '../../../style/styled'
export const PopOverDownloadCSV = ({ fileName, dataCSV }: any) => {
  const { t } = useTranslation()
  return (
    <PopOver style={{ margin: '0 10px' }} variant="Bottom-Right">
      <MoreActions>
        <FaEllipsisV />
      </MoreActions>
      <PopOver.Body>
        <>
          <Span
            style={{
              boxShadow: '0 0 2px 0 rgba(0,0,0,0.4)',
              transform: 'rotate(45deg)',
              padding: 5,
              position: 'absolute',
              zIndex: 98,
              right: '15%',
              top: '-15%',
              background: '#fff',
              clipPath: 'polygon(0% 0%, 100% 0%, 0% 100%)'
            }}
          ></Span>
          <Flex
            style={{
              width: 'max-content',
              zIndex: 99,
              position: 'relative',
              background: '#fff'
            }}
            column
          >
            <Flex
              alignItemsCenter
              p={4}
              style={{
                borderBottom: '1px solid rgba(232,232,232)',
                cursor: 'pointer'
              }}
              onClick={() => {
                downloadToCSV({
                  data: dataCSV,
                  options: { header: false },
                  fileName
                })
              }}
            >
              <FaFileDownload
                size={16}
                style={{ marginRight: 5, color: '#2690ff' }}
              />
              <Span variant="secondary">{t('Export as Csv')}</Span>
            </Flex>
          </Flex>
        </>
      </PopOver.Body>
    </PopOver>
  )
}
